import { render, staticRenderFns } from "./organization-department-process-view.vue?vue&type=template&id=ce3bf958"
import script from "./organization-department-process-view.vue?vue&type=script&lang=js"
export * from "./organization-department-process-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports